<div
  #sectionItem
  class="product-container"
  id="product-container-m{{ menu.id }}-s{{ sectionIndex }}-i{{ itemIndex }}"
  [ngClass]="[
    rowViewModel | sectionRowViewModelBasicMethod: 'getReadableStrainType' | lowercase,
    menu | productMenuBasicMethod: 'getProductWrapperClass' : odd
  ]"
  [class.odd]="odd"
  [class.even]="!odd"
  [class.first]="first"
  [class.last]="last"
  [class.force-bold-style]="viewModel.forcedRowBoldStyling$ | async"
  [class.force-italic-style]="viewModel.forcedRowItalicStyling$ | async"
  [class.has-background-color]="viewModel.rowBackgroundColor$ | async | getArrayElementAtIndex: 1"
  [ngStyle]="viewModel.productWrappingStyle$ | async"
  [style.background-color]="viewModel.rowBackgroundColor$ | async | getArrayElementAtIndex: 1"
  [style.color]="viewModel.forcedRowTextColorToDisplay$ | async"
  [style.text-decoration-color]="viewModel.forcedRowTextColor$ | async"
  [style.zoom]="viewModel.forcedRowZoom$ | async"
  [style.border-color]="viewModel.sectionBorderColor$ | async">
  <ng-container
    *rxFor="
      let colVm of viewModel.columnViewModels$;
      trackBy: trackByColViewModelId;
      strategy: 'immediate';
      let first = first;
      let last = last
    ">
    <!--    Lay out product title column    -->
    <app-column-name
      *ngIf="colVm.columnType === Types.SectionColumnProductInfoType.ProductTitle"
      [calculationMode]="calculationMode"
      [menu]="menu"
      [section]="section"
      [colVm]="colVm"
      [allColVms]="viewModel.columnViewModels$ | async"
      [fixedLocationData]="viewModel.fixedLocationViewModels$ | async"
      [rowVm]="rowViewModel"
      [locConfig]="locationConfig"
      [locationId]="locationId"
      [productStylingVm]="viewModel"
      [reset]="reset"
      [checkForPriceChange]="viewModel.checkForPriceChange$ | async"
      [first]="first"
      [last]="last">
    </app-column-name>
    <!--    Lay out non-title columns    -->
    <app-column-wrapper
      [menu]="menu"
      [section]="section"
      [colVm]="colVm"
      [rowVm]="rowViewModel"
      [locConfig]="locationConfig"
      [locationId]="locationId"
      [productStylingVm]="viewModel"
      [ignoreColConfigWidth]="colVm | ignoreLabelColumnWidth: viewModel.menu$ | async"
      [currentLabelText]="viewModel.labelText$ | async"
      [first]="first"
      [last]="last">
      @if (colVm?.columnType === Types.SectionColumnProductInfoType.VariantPrice) {
        <app-column-primary-price
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [checkForPriceChange]="viewModel.checkForPriceChange$ | async" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.VariantSecondaryPrice) {
        <app-column-secondary-price
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.QuantityAndSize) {
        <app-column-quantity-and-size
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Quantity) {
        <app-column-quantity
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Stock) {
        <app-column-quantity-in-stock
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.VariantType) {
        <app-column-variant-type
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Size) {
        <app-column-size
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.StrainType) {
        <app-column-strain-type
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Strain) {
        <app-column-strain
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Producer) {
        <app-column-producer
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Brand) {
        <app-column-brand
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Lineage) {
        <app-column-lineage
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Spacer) {
        <app-column-spacer
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.TinySpacer) {
        <app-column-tiny-spacer
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Badge) {
        <app-column-badge
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [reset]="reset" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Label) {
        <app-column-label
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [calculationMode]="calculationMode"
          [checkForPriceChange]="viewModel.checkForPriceChange$ | async" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Asset) {
        <app-column-asset
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [reset]="reset" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.GradingResults) {
        <app-column-grading-results
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.HelpsWith) {
        <app-column-helps-with
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [displayFormat]="colVm?.columnConfig?.dataValue"
          [columnListLayoutModifierClass]="this | method: 'getLayoutModifierClassForListColumn' : colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Effects) {
        <app-column-effects
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [displayFormat]="colVm?.columnConfig?.dataValue"
          [columnListLayoutModifierClass]="this | method: 'getLayoutModifierClassForListColumn' : colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Aroma) {
        <app-column-aroma
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [displayFormat]="colVm?.columnConfig?.dataValue"
          [columnListLayoutModifierClass]="this | method: 'getLayoutModifierClassForListColumn' : colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Appearance) {
        <app-column-appearance
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [displayFormat]="colVm?.columnConfig?.dataValue"
          [columnListLayoutModifierClass]="this | method: 'getLayoutModifierClassForListColumn' : colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.GrowingConditions) {
        <app-column-growing-conditions
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [displayFormat]="colVm?.columnConfig?.dataValue"
          [columnListLayoutModifierClass]="this | method: 'getLayoutModifierClassForListColumn' : colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.CraftDesignation) {
        <app-column-craft-designation
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [displayFormat]="colVm?.columnConfig?.dataValue"
          [columnListLayoutModifierClass]="this | method: 'getLayoutModifierClassForListColumn' : colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.Flavor) {
        <app-column-flavor
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [displayFormat]="colVm?.columnConfig?.dataValue"
          [columnListLayoutModifierClass]="this | method: 'getLayoutModifierClassForListColumn' : colVm" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.TopFlavor) {
        <app-column-top-flavor
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm?.columnType === Types.SectionColumnProductInfoType.EnergyScore) {
        <app-column-energy-score
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm?.columnType | isCannabinoidColumn) {
        <app-column-cannabinoid
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [cannabinoidColumnType]="colVm?.columnType | isCannabinoidColumn"
          [displayFormat]="colVm?.columnConfig?.dataValue"
          [columnListLayoutModifierClass]="this | method: 'getLayoutModifierClassForListColumn' : colVm" />
      } @else if (colVm?.columnType | isTerpeneColumn) {
        <app-column-terpene
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [terpeneColumnType]="colVm?.columnType | isTerpeneColumn"
          [displayFormat]="colVm?.columnConfig?.dataValue"
          [columnListLayoutModifierClass]="this | method: 'getLayoutModifierClassForListColumn' : colVm" />
      } @else if (colVm?.columnType | isProductTagGroupColumn) {
        <app-column-product-tag-group
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [productTagGroupColumnType]="colVm?.columnType | isProductTagGroupColumn"
          [displayFormat]="colVm?.columnConfig?.dataValue"
          [columnListLayoutModifierClass]="this | method: 'getLayoutModifierClassForListColumn' : colVm" />
      }
    </app-column-wrapper>
  </ng-container>
</div>
